import React from 'react';
import LocaleContextProvider from './components/context/LocaleContext';
import LocalizedStringsContextProvider from './components/context/LocalizedStringsContext';
import TranslationsProvider from './components/context/TranslationsContext';
import ErrorBoundary from './components/errorBoundary';
import Routes from './components/routes';
import SessionTimeout from './helpers/session-timeout';

const App = () => {
  return (
    <LocaleContextProvider>
      <LocalizedStringsContextProvider>
        <ErrorBoundary>
          <TranslationsProvider>
            <SessionTimeout>
              <Routes />
            </SessionTimeout>
          </TranslationsProvider>
        </ErrorBoundary>
      </LocalizedStringsContextProvider>
    </LocaleContextProvider>
  );
};

export default App;
